import React from 'react';
import { connect, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';
import { Button, Form, Label, FormGroup, Card, CardBody, CardHeader, CardFooter, CardTitle, Row, Col } from 'reactstrap';
import { mdiContentSave, mdiLoading, mdiAlert } from '@mdi/js';
import Icon from '@mdi/react';
import { Transaction } from '../../../models';

let AccountForm = ({ isCreation, handleSubmit, pristine, submitting, accountChoices = [] }) => {
    const { t } = useTranslation();
    const {
        isLoadingOne,
        loadingOneErrorMessage,
        loadingOneFieldErrors
    } = useSelector(state => state.accounts);

    const renderFieldErrors = (fieldName) => {
        const errors = loadingOneFieldErrors?.[fieldName] || [];
        if (errors.length === 0) {
            return null;
        }

        return (
            <small className="text-danger d-block mt-1">
                { errors.join(' - ') }
            </small>
        );
    };

    return (
        <Form className="form" onSubmit={ handleSubmit }>
            <Card>
                <CardHeader>
                    <Row>
                        <Col>
                            <CardTitle>{ isCreation ? t('accounts.add_title') : t('accounts.edit_title') }</CardTitle>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody>
                    {(loadingOneErrorMessage?.length > 0) && (
                        <div className="w-100 text-center mb-3">
                            <Label className="text-danger">
                                <Icon path={ mdiAlert } size={ 1 } color="red" />&nbsp;
                                { loadingOneErrorMessage }
                            </Label>
                        </div>
                    )}
                    <FormGroup>
                        <Label for="name">{ t('accounts.name') }</Label>
                        <Field component="input" className="form-control" placeholder={ t('accounts.name') } name="name" id="name" required />
                        { renderFieldErrors('name') }
                    </FormGroup>

                    <FormGroup>
                        <Label for="iban">{ t('accounts.iban') }</Label>
                        <Field component="input" className="form-control" placeholder={ t('accounts.iban') } name="iban" id="iban" required />
                        { renderFieldErrors('iban') }
                    </FormGroup>

                    <FormGroup>
                        <Label for="currency">{ t('accounts.currency') }</Label>
                        <Field component="select" className="form-control" placeholder={ t('accounts.currency') } name="currency" id="currency" required>
                            { Transaction.currencies().map(currency => <option key={ currency } value={ currency }>{currency}</option>) }
                        </Field>
                        { renderFieldErrors('currency') }
                    </FormGroup>

                    <FormGroup>
                        <Label for="beneficiary_name">{ t('accounts.beneficiary_name') }</Label>
                        <Field component="input" className="form-control" placeholder={ t('accounts.beneficiary_name') } name="beneficiary_name" id="beneficiary_name" required />
                        { renderFieldErrors('beneficiary_name') }
                    </FormGroup>

                    <FormGroup>
                        <Label for="beneficiary_address">{ t('accounts.beneficiary_address') }</Label>
                        <Field component="textarea" className="form-control" placeholder={ t('accounts.beneficiary_address') } name="beneficiary_address" id="beneficiary_address" />
                        { renderFieldErrors('beneficiary_address') }
                    </FormGroup>

                    <FormGroup>
                        <Label for="rate_fallback_account_id">{ t('accounts.rate_fallback_account') }</Label>
                        <Field component="select" className="form-control" name="rate_fallback_account_id" id="rate_fallback_account_id">
                            <option value="">{ t('accounts.rate_fallback_account_none') }</option>
                            { accountChoices.map((a) => (
                                <option key={ a.id } value={ a.id }>{ a.name }</option>
                            )) }
                        </Field>
                        { renderFieldErrors('rate_fallback_account_id') }
                    </FormGroup>
                </CardBody>
                <CardFooter className="text-right">
                    <Button type="submit" color="success" disabled={ pristine || submitting || isLoadingOne }>
                        { isLoadingOne && <Icon path={ mdiLoading } size={ 1 } spin={ 1 } color="white" /> }
                        { !isLoadingOne && <Icon path={ mdiContentSave } size={ 1 } color="white" /> }
                        &nbsp;{t("common.save")}
                    </Button>
                </CardFooter>
            </Card>
        </Form>
    );
}

AccountForm = reduxForm({
    form: 'accountForm',
    enableReinitialize: true,
})(AccountForm)

AccountForm = connect(
    state => ({
        initialValues: state.accounts.account
    })
)(AccountForm)

export default AccountForm;
